import { useState, useEffect } from 'react';
import { Container, Navbar, Nav, Button } from 'react-bootstrap';
import { Sun, Moon, List } from 'react-bootstrap-icons';
import { useLocation } from 'react-router-dom';
import './Header.scss';

const Header = () => {
    const location = useLocation();

    const [darkMode, setDarkMode] = useState(() => {
        // Read initial theme from localStorage
        return localStorage.getItem('theme') === 'dark';
    });

    useEffect(() => {
        // Apply theme class directly
        if (darkMode) {
            document.body.classList.add('dark-theme');
            localStorage.setItem('theme', 'dark');
        } else {
            document.body.classList.remove('dark-theme');
            localStorage.setItem('theme', 'light');
        }
    }, [darkMode]); // Only runs when darkMode changes

    const toggleTheme = () => {
        setDarkMode(!darkMode);
    };
    return (
        <Navbar expand="lg" fixed="top" className="navbar-custom">
            <Container fluid>
                {/* Mobile menu button - centered */}
                <Navbar.Toggle
                    aria-controls="basic-navbar-nav"
                    className="mx-auto d-lg-none position-absolute start-50 translate-middle-x"
                >
                    <List size={20} />
                </Navbar.Toggle>

                {/* Theme toggle - always on right */}
                <div className="d-lg-none position-absolute end-0 me-3">
                    <Button
                        variant="link"
                        className="theme-toggle"
                        onClick={toggleTheme}
                    >
                        {darkMode ? <Sun size={20} /> : <Moon size={20} />}
                    </Button>
                </div>

                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="mx-auto">
                        <Nav.Link
                            href="/"
                            className={`nav-link-blue ${location.pathname === '/' ? 'active' : ''}`}
                        >
                            Home
                        </Nav.Link>

                        <Nav.Link
                            href="/standings"
                            className={`nav-link-blue ${location.pathname === '/standings' ? 'active' : ''}`}
                        >
                            Tabella
                        </Nav.Link>

                        <Nav.Link
                            href="/matches"
                            className={`nav-link-blue ${location.pathname === '/matches' ? 'active' : ''}`}
                        >
                            Meccsek
                        </Nav.Link>

                        <Nav.Link
                            href="/scorers"
                            className={`nav-link-blue ${location.pathname === '/scorers' ? 'active' : ''}`}
                        >
                            Góllövők
                        </Nav.Link>
                    </Nav>

                    {/* Theme toggle - desktop */}
                    <div className="d-none d-lg-block">
                        <Button
                            variant="link"
                            className="theme-toggle"
                            onClick={toggleTheme}
                        >
                            {darkMode ? <Sun size={20} /> : <Moon size={20} />}
                        </Button>
                    </div>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default Header;